Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Dropdown3122138349",
  {"root":"Dropdown3122138349--root","dropdownContent":"Dropdown3122138349--dropdownContent"},
  ".Dropdown3122138349--root .Popover1478472482--popover{min-width:100%}",
  3,
  "Dropdown3122138349"
);
__webpack_require__.stylable.$.register(exports.default)
